import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from 'seagull';
import { BillingType } from '~/components/BillModal/BillClientModal.types';
import { serviceModel } from '~/models';
import { utils } from '~/utils';
import { getCellStates } from '../../utils/lineItem.utils';
import { DescriptionInput, DiscountInput, QuantityInput, RateInput } from './columns';
import { lineItemTotal, preapprovedText, rateText, resolveServiceCost } from './columns.utils';
const SHEET_DESCRIPTION_MIN_ROWS = 4;
const DisabledSheetField = (rowIndex, cellKey, value, params)=>/*#__PURE__*/ _jsx(TextField, {
        bi: {
            name: "bill_item_edit_disabled_".concat(cellKey)
        },
        size: "medium",
        disabled: true,
        testId: params.testIds.EditDisabledField(rowIndex, cellKey),
        value: value
    });
const serviceSheetFieldNode = (item, rowIndex, params, cellKey, state)=>{
    if (cellKey === 'quantity') return QuantityInput(item, rowIndex, params);
    if (cellKey === 'rate') {
        if (state === 'input') return RateInput(item, rowIndex, params);
        const value = rateText(resolveServiceCost(item), params.texts.costDisplayTexts);
        return DisabledSheetField(rowIndex, 'rate', String(value), params);
    }
    if (cellKey === 'discount') {
        const discount = serviceModel.discount(item.fullService);
        return DisabledSheetField(rowIndex, 'discount', discount ? discount.format() : '', params);
    }
    if (cellKey === 'preapproved') {
        const value = preapprovedText(resolveServiceCost(item));
        return DisabledSheetField(rowIndex, 'preapproved', String(value), params);
    }
    return DescriptionInput(rowIndex, params, SHEET_DESCRIPTION_MIN_ROWS);
};
const chargeSheetFieldNode = (item, rowIndex, params, cellKey)=>{
    if (cellKey === 'quantity') return QuantityInput(item, rowIndex, params);
    if (cellKey === 'rate') return RateInput(item, rowIndex, params);
    if (cellKey === 'discount') return DiscountInput(item, rowIndex, params);
    return DescriptionInput(rowIndex, params, SHEET_DESCRIPTION_MIN_ROWS);
};
const buildFields = (item, rowIndex, params, fieldNode)=>{
    const states = getCellStates(item);
    const { tableHeaders } = params.texts;
    const order = [
        {
            key: 'quantity',
            label: tableHeaders.quantity(),
            include: true
        },
        {
            key: 'rate',
            label: tableHeaders.rate(),
            include: true
        },
        {
            key: 'discount',
            label: tableHeaders.discount(),
            include: true
        },
        {
            key: 'preapproved',
            label: tableHeaders.preapproved(),
            include: params.includePreapproved
        },
        {
            key: 'description',
            label: tableHeaders.description(),
            include: true
        }
    ];
    return order.filter((param)=>{
        let { key, include } = param;
        return include && states[key] !== 'empty';
    }).map((param)=>{
        let { key, label } = param;
        return {
            key,
            label,
            node: fieldNode(key, states[key])
        };
    });
};
export const buildSheetFields = (item, rowIndex, params)=>item.type === BillingType.Service ? buildFields(item, rowIndex, params, (cellKey, state)=>serviceSheetFieldNode(item, rowIndex, params, cellKey, state)) : buildFields(item, rowIndex, params, (cellKey)=>chargeSheetFieldNode(item, rowIndex, params, cellKey));
export const sheetTotalText = (item)=>{
    const total = lineItemTotal(item);
    return total != null ? utils.formatDollarAmount(total) : '';
};
